import AppManagement from "../views/developerCenter/appManagement"
import AccessKeyManagement from "../views/developerCenter/accessKeyManagement"
import CallbackAddress from "../views/developerCenter/callbackAddress"
import NotFound from "../views/developerCenter/exception/404";
import NoServer from "../views/developerCenter/exception/500";
import NoPermission from "../views/developerCenter/exception/403";
import UserAgreement from "src/components/gs-web-ui/Footer/agreements/UserAgreement";
import PrivacyAgreement from "src/components/gs-web-ui/Footer/agreements/PrivacyAgreement";
export const developerCenterRoutes = [
  {
    path: '/developerCenter/appManagement',
    element: <AppManagement/>,
    canAccessRole: ['DEVELOPER']
  },
  {
    path: '/developerCenter/accessKeyManagement',
    element: <AccessKeyManagement/>,
    canAccessRole: ['DEVELOPER']
  },
  {
    path: '/developerCenter/callbackAddress',
    element: <CallbackAddress/>,
    canAccessRole: ['DEVELOPER']
  },
  {
    path: '/app/agreements/user-agreement',
    element: <UserAgreement/>,
  },
  {
    path: '/app/agreements/privacy-agreement',
    element: <PrivacyAgreement/>,
  },
  {
    path: "/exception/404",
    element: <NotFound />,
  },
  {
    path: "/exception/500",
    element: <NoServer />,
  },
  {
    path: "/exception/403",
    element: <NoPermission />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]
